
export default function IntroSection() {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
          <p className="text-xl">
            In a world of constant communication, it's easy to confuse connection with noise. Real partnerships aren't built on volume. They're built on resonance.
          </p>

          <p className="text-xl">
            When you're clear on who you are, what you value, and what you're building, the right people notice. Not because you're louder, but because you're aligned.
          </p>

          <p className="text-xl">
            This isn't about chasing partnerships. It's about creating the conditions where the right ones find you and stick.
          </p>

          <p className="text-xl">
            I've seen it happen over and over: when partnerships are rooted in trust, clarity, and shared purpose, they don't just work. They amplify. They create momentum, open doors, and lead to opportunities you couldn't have planned for.
          </p>

          <p className="text-xl">
            The old model of business was built on competition and scarcity. The new model is built on collaboration and abundance. There's room for all of us when we're working from alignment.
          </p>

          <p className="text-xl font-medium text-gray-900">
            To me, that's the future. There's room for all of us when partnerships are aligned, valuable, and rooted in trust.
          </p>
        </div>
      </div>
    </section>
  );
}
